document.addEventListener('DOMContentLoaded', function () {
    const inputs = document.querySelectorAll('input[data-enforce-min]');

    inputs.forEach(input => {
        input.addEventListener('blur', () => {
            const min = parseInt(input.dataset.min) || 1;
            const val = parseInt(input.value);

            if (isNaN(val) || val < min) {
                input.value = min;
            }
        });
    });
});
